import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import SettingsIcon from '@material-ui/icons/Settings';
import IconButton from '@material-ui/core/IconButton';

import React from 'react';
import { useHistory } from 'react-router-dom';

import { baseTheme } from '../../theme';
import { ROUTE_PATHS } from '../../contants/ROUTE_PATHS';
import SubmitButton from '../form-elements/submit-button';
import { signOutUser } from '../../services';
import HeaderNavItem from '../navigation-components/header-nav-item';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logOutContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    userDisplayName: {
      textAlign: 'right',
      paddingRight: '1em',
      fontSize: '1.2em',
      fontWeight: 'bold',
    },
    iconContainers: {
      textAlign: 'center',
    },
    logOutButton: {
      fontSize: '1em',
      width: '100%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    iconSpacer: {
    },
    userIconImage: {
      width: '3.5em',
      height: '3.5em',
      borderRadius: '100%',
    },
  }),
);

export default function UserDetailsForm(props: any) {
  const { displayName } = props.currUser;
  const classes = useStyles(baseTheme);
  const history = useHistory();

  const handleLogOut = async () => {
    await signOutUser();
    history.push(ROUTE_PATHS.HOME);
  };

  const handleSettingsClick = () => {
    history.push(ROUTE_PATHS.ADMIN_USER_SETTINGS);
  };

  const renderIcon = () => {
    if (props.currUser.photoUrl) {
      const image = props.currUser.photoUrl;
      return <img
        src={image}
        alt="User Image"
        className={classes.userIconImage} />;
    }
    return <AccountCircleIcon className={classes.iconSpacer} />;
  };

  return (
    <Grid item container xs={12} className={classes.logOutContainer}>
      <Grid item xs={8} className={classes.userDisplayName}>
        Hello, {displayName}
      </Grid>

      <Grid item xs={1} className={classes.iconContainers}>
        {renderIcon()}
      </Grid>

      <Grid item xs={1} className={classes.iconContainers}>
        <IconButton color="inherit" onClick={handleSettingsClick}>
          <SettingsIcon />
        </IconButton>
      </Grid>

      <Grid item xs={2}>
        <HeaderNavItem
          onClick={handleLogOut}
          title="Log out"
        />
      </Grid>
    </Grid>
  );
}
